import { format } from 'date-fns';

interface AuthSettingsItemProps {
  title: string;
  description: React.ReactNode;
  fieldType: 'UPDATED' | 'ACTIVATE' | 'INFO';
  actionDate?: Date;
  borderBottom?: boolean;
  actionOnClick: () => void;
}

const AuthSettingsItem = ({ title, description, fieldType, actionDate, borderBottom = false, actionOnClick }: AuthSettingsItemProps) => {
  return (
    <>
      <div className='flex w-full cursor-pointer flex-col md:grid md:grid-cols-[1fr_200px]' onClick={actionOnClick}>
        <div className='flex w-full flex-col justify-center gap-2'>
          <div className='text-blue-primary text-lg font-bold'>{title}</div>
          <div className='text-black'>{description}</div>
        </div>
        {actionDate && (
          <div className='text-blue-primary my-auto mt-5 mr-auto text-center text-xs md:mt-0 md:ml-auto'>
            {fieldType === 'UPDATED' ? 'Mis à jour le' : 'Activé le'} {format(actionDate, 'dd/MM/yyy')}
          </div>
        )}
      </div>
      {borderBottom && <div className='border-b-gray-tertiary -my-1 w-full border-b'></div>}
    </>
  );
};

export default AuthSettingsItem;
